import { render, staticRenderFns } from "./ManageActions.vue?vue&type=template&id=238c6e10&scoped=true"
import script from "./ManageActions.vue?vue&type=script&lang=js"
export * from "./ManageActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238c6e10",
  null
  
)

export default component.exports